<template>
    <div class="p-2 widget my-2">
        <div class="row">
            <div class="col-12">
                <p class="text-uppercase font-weight-bold mb-0">Patient Insurance Information</p>
            </div>
        </div>
        <template v-for="f in fundings">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex flex-column">
                            <p class="mb-0 mt-2 font-weight-bold">{{ f.source.name }}</p>
                        </div>
                        <div class="d-flex flex-column align-items-end"></div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <p class="mb-0">
                            Phone Number: {{ helpers.formatPhone(f.source.primary_phone) }}
                        </p>
                    </div>

                    <template v-for="c in f.contracts.filter(contract => !contract.is_archived)">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex flex-column">
                                <p class="mb-0">Member ID# {{ c ? c.identifier : "" }}</p>
                            </div>
                            <div class="d-flex flex-column align-items-end">
                                <a
                                    class="font-weight-bold link-primary float-right"
                                    :class="canEditClientFunding ? 'text-primary' : 'text-muted'"
                                    @click="canEditClientFunding ? editContract(f, c) : null"
                                    >Edit</a
                                >
                                <span class="float-right"
                                    >Last Updated:
                                    {{
                                        c.eligibility_updated_at
                                            ? moment(c.eligibility_updated_at).format("MM-DD-YY")
                                            : "N/A"
                                    }}</span
                                >
                            </div>
                        </div>
                        <div class="row">
                            <p class="col-6 mb-0">
                                Co-insurance %: {{ c ? c.coinsurance_percentage : "" }}
                            </p>
                            <p class="col-6 mb-0">Copay: {{ c ? c.copay_value : "" }}</p>
                        </div>

                        <div class="row">
                            <p class="col-6 mb-0">
                                Deductible amount: {{ c ? c.deductible_amount : "" }}
                            </p>
                            <p class="col-6 mb-0">
                                Deductible met: {{ c ? c.deductible_amount_met : "" }}
                            </p>
                        </div>

                        <div class="row">
                            <p class="col-6 mb-0">
                                Max out of pocket: {{ c ? c.max_out_of_pocket_amount : "" }}
                            </p>
                            <p class="col-6 mb-0">
                                Max out of pocket met: {{ c ? c.max_out_of_pocket_amount_met : "" }}
                            </p>
                        </div>

                        <div class="d-flex justify-content-between mb-3">
                            <p class="mb-0">
                                Visits per year: {{ c.options ? c.options.days_week_seen : "" }}
                            </p>
                        </div>
                        <hr class="bar" />
                    </template>
                </div>
            </div>
        </template>
        <patient-insurance-edit
            :funding="funding"
            :contract="contract"
            @close="closeEdit()"
            @refresh-fundings="refreshFundings()"
        ></patient-insurance-edit>
    </div>
</template>

<script>
import { helpers } from "../../plugins/helpers";
import { permissions } from "../../plugins/permissions";
import PatientInsuranceEdit from "./PatientInsuranceEdit";

export default {
    name: "PatientInsuranceInfo",
    props: ["patient", "fundings"],
    components: { PatientInsuranceEdit },
    mixins: [permissions],
    data() {
        return {
            helpers,
            insuranceProviders: [],
            funding: {},
            contract: {},
        };
    },
    methods: {
        refreshFundings() {
            this.$emit("refresh-fundings");
        },
        editContract(funding, contract) {
            this.funding = { ...funding };
            this.contract = { ...contract };
        },
        closeEdit() {
            this.contract = {};
        },
    },
};
</script>

<style scoped></style>
